(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hiranya-product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hiranya-shipping-link]');
    if (!link) return;
    const accordion = document.getElementById(link.hash.slice(1));
    if (!accordion) return;
    accordion.open = true;
    accordion.querySelector('summary').focus({ preventScroll: true });
  });

  if (!customElements.get('hiranya-pdp-offers')) {
    customElements.define('hiranya-pdp-offers', class extends HTMLElement {
      connectedCallback() {
        this.syncOffers = this.syncOffers || this.renderOffers.bind(this);
        this.syncOffers();
        document.addEventListener('DOMContentLoaded', this.syncOffers, { once: true });
        document.addEventListener('shopify:section:load', this.syncOffers);
        document.addEventListener('shopify:section:unload', this.syncOffers);
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.syncOffers);
        document.removeEventListener('shopify:section:load', this.syncOffers);
        document.removeEventListener('shopify:section:unload', this.syncOffers);
      }

      renderOffers(event) {
        const list = this.querySelector('ul');
        const template = this.querySelector('template');
        if (!list || !template) return;

        const announcements = document.querySelectorAll('.hiranya-announcement__track > span');
        const offers = new Set();
        announcements.forEach((announcement) => {
          if (event && event.type === 'shopify:section:unload' && event.target.contains(announcement)) return;
          const text = announcement.textContent.replace(/\s+/g, ' ').trim();
          if (text) offers.add(text);
        });

        const items = document.createDocumentFragment();
        offers.forEach((text) => {
          const item = template.content.cloneNode(true);
          item.querySelector('span').textContent = text;
          items.appendChild(item);
        });
        list.replaceChildren(items);
        this.hidden = offers.size === 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
